import { useState, useEffect } from 'react'
import { store } from '../store'
import { urlMedia } from '../config'

export const useMediaUrl = (path: string | null | undefined): string | null => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!path) {
      setObjectUrl(null)
      return
    }

    let revoked = false
    let currentObjectUrl: string | null = null

    const load = async () => {
      const token = store.getState().user.user.auth_token || ''

      try {
        const res = await fetch(`${urlMedia}${path}`, {
          headers: { Authorization: `Bearer ${token}` },
        })

        if (!res.ok || revoked) return

        const blob = await res.blob()
        if (revoked) return

        currentObjectUrl = URL.createObjectURL(blob)
        setObjectUrl(currentObjectUrl)
      } catch {
        // media unavailable
      }
    }

    load()

    return () => {
      revoked = true
      if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl)
    }
  }, [path])

  return objectUrl
}
